var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFoward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3839 6.0303C13.091 5.7374 13.091 5.2626 13.3839 4.9697C13.6768 4.6768 14.1517 4.6768 14.4445 4.9697L20.2374 10.7626C20.9209 11.446 20.9209 12.554 20.2374 13.2374L14.4445 19.0303C14.1517 19.3232 13.6768 19.3232 13.3839 19.0303C13.091 18.7374 13.091 18.2626 13.3839 17.9697L18.6036 12.75L3.91427 12.75C3.49997 12.75 3.16427 12.4142 3.16427 12C3.16427 11.5858 3.49997 11.25 3.91427 11.25L18.6036 11.25L13.3839 6.0303Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFoward);
export default __webpack_public_path__ + "static/media/arrow-foward.dde3e78b5b7bd56618514010fdf95b9c.svg";
export { ForwardRef as ReactComponent };